{
  "test": "Test msg",
  "email_subscribe_header": "Be the first to know",
  "email": "Email",
  "password": "Password",
  "recovery": "Password recovery",
  "recovery_subtitle": "Confirmation code sent to",
  "recovery_code": "Enter a code",
  "forgot_pass": "Forgot your password?",
  "pass": "Enter your password",
  "pass_subtitle": "You have enabled two-steps verification. Your account is protected by an additional password.",
  "your_email": "Your email",
  "your_password": "Your password",
  "subscribe": "Subscribe",
  "rights": "© 2024 CardBook. All rights reserved.",
  "terms": "Terms",
  "privacy": "Privacy",
  "quick_links": "Quick links",
  "news": "News",
  "packages": "Packages",
  "about_us": "About us",
  "how_it_works": "How it works",
  "main_functions": "Main functions",
  "contacts": "Contacts",
  "sign_in": "Sign in",
  "create_account": "Create an account",
  "next": "Next",
  "back": "Back",
  "confirm": "Confirm",
  "send": "Send",
  "resend_code": "Send code again",
  "resend": "Send code",
  "invalid_code": "Invalid code",
  "terms_accept_checkbox": "I have read and agree to the Terms and Conditions and the Privacy Policy",
  "terms_accept_required": "Please accept the Terms and Conditions and Privacy Policy to continue",
  "terms_updated_title": "Our Terms and Privacy Policy have been updated",
  "terms_updated_body": "Please review and accept the updated documents to continue using CardBook.",
  "terms_updated_on": "Last updated: {date}",
  "terms_accept_button": "Accept and continue",
  "country": "Country",
  "sign_in_to": "Sign in to CardBook",
  "sign_up_to": "Sign up to CardBook",
  "keep_me_signed_in": "Keep me signed in",
  "sign_in_subtitle": "To log in, please verify your country and enter your phone number.",
  "email_sign_in_subtitle": "To sign in, enter your email or continue with your phone number",
  "sign_in_by_email": "Sign in by email",
  "sign_in_by_phone": "Sign in by phone number",
  "pin_subtitle": "We have sent the code to the verified phone.",
  "pin_email_subtitle": "We have sent the code to the specified email",
  "didnt_receive_code": "Didn’t receive the code?",
  "sign_in_with_email": "Sign in with email",
  "no_code_hint": "The code may not arrive due to operator or country restrictions. We are working on a solution and will fix this issue soon.",
  "set_new_password": "Set a new password",
  "set_new_password_subtitle": "Please create a new password for your account",
  "link_email": "Link your email",
  "link_email_subtitle": "This is necessary for password reset, account activation, and sign-in.",
  "registration_subtitle": "We noticed that you are with us for the first time! To create an account, fill in the required fields.",
  "reg_agreement": "By registering, you agree with the <a style='color: #4497B0; text-decoration: underline;' href='{terms}' target='_blank' rel='noopener'>Terms and conditions</a> and <a style='color: #4497B0; text-decoration: underline;' href='{privacy}' target='_blank' rel='noopener'>Privacy Policy</a>, including the <a style='color: #4497B0; text-decoration: underline;' href='{cookie}' target='_blank' rel='noopener'>Cookie Policy</a>.",
  "first_name": "First name",
  "last_name": "Last name",
  "my_profile": "My profile",
  "my_cabinet": "My cabinet",
  "settings": "Settings",
  "log_out": "Log out profile",
  "overview": "Overview",
  "search": "Search",
  "digital_bank": "Digital Bank",
  "chat": "Chat",
  "connector": "Connector",
  "info_hub": "InfoHub",
  "subscriptions": "Subscriptions",
  "support": "Support",
  "help": "Help",
  "terms_tool": "Terms",
  "privacy_tool": "Privacy",
  "more": "More",
  "log_out_": "Log out",
  "begin": "Begin",
  "phone": "Phone number",
  "curr_detail": "Enter your current information. Upload a photo to your profile and fill in the actual details. This is a crucial step that allows any user visiting your profile to get to know you and understand what you're involved in.",
  "edit_profile_text": "Your profile is now complete. Having a photo on your profile is essential, as it helps users understand who you are and what you're involved in. Keep your information updated for better networking",
  "find_friend": "Find your friends on the platform or download their business cards and save them to Digital Bank. We recommend that you immediately sort them and specify the level of access to the contact. (Learn more about CardBook access levels",
  "find_friend_link": "here)",
  "search_section": "Visit the Search section - this is where your business card will be displayed after filling out your profile. It's an endless stream of valuable contacts and people you can connect with on CardBook.",
  "might_be": "Might be helpful",
  "useful_video": "Useful video",
  "fresh_events": "Fresh events",
  "validation_required": "Field is required.",
  "validation_email": "Enter valid email.",
  "validation_url": "Enter valid URL",
  "validation_password": "Password must include minimum eight characters, at least one number, one uppercase and one lowercase letter.",
  "validation_password_confirm": "Passwords must match.",
  "validation_min": "{field} should be at least {n} characters long.",
  "validation_max": "{field} maximum length allowed is {n}.",
  "validation_birth": "Enter correct date.",
  "validation_phone": "Enter a valid phone number.",
  "validation_min_phone": "Phone number should be at least 10 characters long.",
  "validation_max_phone": "Phone number maximum length allowed is 14.",
  "error": "Error",
  "mail_exist": "This email has already been used",
  "error_login": "Wrong phone.",
  "error_phone": "You have entered an incorrect number",
  "error_pass": "Wrong password.",
  "error_pin": "Wrong pincode.",
  "error_registration": "Registration error.",
  "error_update_user": "Error update data user.",
  "error_server": "Error server.",
  "error_occurred": "An Error Occurred.",
  "translation_failed": "Couldn't translate. Showing the original text.",
  "error_update_image": "Upload image error.",
  "complete_profile": "Complete your profile",
  "add_card": "Add business card",
  "expand": "Expand Networking",
  "btn_fill": "Fill out profile",
  "visit_secret": "Visit Search",
  "welcome": "Welcome!",
  "welcome_banner": "Welcome",
  "joined": "You have joined CardBook",
  "text_modal": "CardBook is a platform where you have endless possibilities! Monetize your business and personal contacts, communities, business clubs, create useful contacts, and all these on one online platform!",
  "edit": "Edit your profile",
  "processing": "Processing..",
  "not_found": "Page Not Found",
  "not_found_text": "Sorry, but we couldn't find the requested page. It's possible that the link you entered is invalid or the page has been moved.",
  "home": "Home",
  "cardMarket": "CardMarket",
  "remaining": "Remaining",
  "add_new_contact": "Add new contact",
  "name": "Name",
  "surname": "Surname",
  "competence": "Competence",
  "profile_miss": "Profile missing information",
  "attention_modal": "If you want to add content,you must complete all the details in your       personal profile.",
  "later": "Later",
  "fill_btn": "Fill out a profile",
  "no_email": "No email linked",
  "no_email_text": "If you want to add content, you must link your email.",
  "add_email": "Add Email",
  "add": "Add",
  "no_matches": "No matches were found on the platform for the specified data",
  "add_text": "If the right person is not on the list",
  "city": "City",
  "direction": "Direction",
  "talk_language": "Talk language",
  "price_for_access": "Price for access",
  "write_text": "Write hint text",
  "Newbie": "Newbie",
  "Skilled": "Skilled",
  "Expert": "Expert",
  "edit_cover": "Edit Photo",
  "edit_profile": "Edit profile",
  "remove_cover": "Remove Photo",
  "select_cover": "Select Photo",
  "view_photo": "View Photo",
  "about_me": "About me",
  "industries": "Industries",
  "directions": "Directions",
  "competences": "Competences",
  "expertise": "Expertise level",
  "languages": "Talk language",
  "load_more": "Load more",
  "save": "Save",
  "delete_this_contact": "Delete this contact",
  "add_to_bank": "Add to Digital Bank",
  "socials": "Social Networks",
  "subscribers": "Subscribers",
  "get_data": "Data loading error",
  "get_access": "Get access",
  "familiar": "If you are familiar with this contact",
  "text_add": "You can add it to your digital bank for storage. Indication of access level and price at will.",
  "level_access": "Level access",
  "add_contact_bank": "You have successfully added a contact",
  "filter": "Filter",
  "reset_filters": "Reset all filters",
  "apply": "Apply",
  "expertise_level": "Expertise level",
  "new_contact": "You add new contact",
  "in_bank": "In your Digital Bank",
  "search_title": "Search for CardBook",
  "search_notif": "This is a virtual directory with an endless stream of business cards, and to be among them, fill out your profile.",
  "tags": "Tags",
  "profile_info": "Profile info",
  "profile_preview": "Profile Preview",
  "your_profile_must_be_completed": "That you and your business cards were included in the general search, Your profile must be completed",
  "basic_information": "Basic information",
  "basic_information_text": "Indicate your personal data to make it easier to find you and inspire more trust in communication.",
  "basic_information_positioning": "Who are you positioning yourself as?",
  "basic_information_positioning_placeholder": "max. 30 characters",
  "avatar_cover_title": "Avatar and cover",
  "avatar_cover_text": "Replace system images with your own. The recommended cover size is 1610x310px.",
  "upload_new_cover": "Upload new cover",
  "location": "location",
  "location_text": "Add information about your primary location. Potential clients will be able to find you by matching filters.",
  "additional_information": "Additional Information",
  "additional_information_text": "Additional information greatly affects the trust in interaction between users. If the user trusts you, he is more willing to contact you and can offer more favorable terms of the transaction.\nWrite what you work for, what you dream about. People trust open people ;)",
  "interest_needs": "Interests & Needs",
  "interest_needs_text": "Boost your networking profile's value by sharing your current needs and interests.",
  "save_profile": "Save Profile",
  "show": "Show",
  "clear": "Clear",
  "potential_income": "Your potential income from contacts of your CardMarket",
  "calculate": "Calculate",
  "networking": "Networking Income Calculator",
  "text_calculator": "Hello! We have created this calculator for the convenience of calculating income when trading on the platform.",
  "comment": "Comment",
  "card_market": "CardMarket",
  "profit_potential": "Profit potential",
  "calculation_result": "Calculation result",
  "monthly_sales": "Monthly sales potential",
  "per_month": "Profit per month",
  "per_year": "Profit per year",
  "taking": "Taking into account*",
  "plat_fee": "Platform Fee",
  "contact_fee": "Your contact's Fee",
  "bank_fee": "Bank Fee",
  "question_1": "What is the networking calculator?",
  "text_1": "It is an interactive tool that allows you to estimate the potential income from using our platform. Once you enter your information, the calculator will show you the estimated monthly and annual revenue and one-time sales per contact. It's a great way to estimate the earning potential of your network of contacts and start using our platform to improve your business or career.",
  "question_2": "Will I only be able to do 20 deals a month?",
  "text_2": "Income in the «Networking Calculator» is calculated based on user-entered data on the price of accessing contacts at three trust levels. The calculator takes into account the total sum of contact prices and estimates the potential profit for a year, a month, and a one-time sale for each contact. Given that a user can introduce up to 20 people per day, the calculator determines the sales potential of each access level by dividing it by 50%",
  "question_3": "What data do I need to enter into the calculator?",
  "text_3": "To use the calculator, you need to enter the number of transactions you can make in a month (the average does not exceed 20) and the average desired price for each access level (A, B, C) on our platform. Based on this data, the calculator will automatically calculate your potential earnings, taking into account the possibility of selling each contact and the number of sales per month.",
  "question_4": "What is the difference between access levels (A, B, C)?",
  "text_4": "Level A — High level of trust in the person. You are in a close relationship with him/her and maintain constant communication.  Level B — Medium level of trust. You are in fairly regular communication with the contact and keep in touch.  Level C — Minimal level of trust. You are familiar with the person but do not have frequent contact with them.",
  "occupation": "Occupation",
  "can_help": "I can help with...",
  "looking": "Looking for",
  "can_introduce": "I can introduce to...",
  "profile_info_text": "Specify tags that best describe you. This will make you more discoverable in the general search.",
  "update_profile": "You have successfully updated information",
  "upload_new": "Upload new",
  "edit_size": "Edit",
  "remove": "Remove",
  "account_info": "Account information",
  "mobile": "Mobile number",
  "change": "Change",
  "not_confirmed": "Not confirmed",
  "confirmed": "Confirmed",
  "security_level": "Security level",
  "good": "Good",
  "average": "Average",
  "delete_profile": "Delete Profile",
  "delete_btn": "Delete",
  "delete_prof_msg": "Are you sure you want to delete your account?",
  "delete_prof": "This action cannot be undone and all of your data will be permanently lost.",
  "deleted_msg": "Your profile has been successfully deleted.",
  "add_password": "Add Password",
  "pass_modal_text": "You can set a password that will be required when logging in from a new device to an SMS code",
  "repeat_password": "Repeat password",
  "pin_mail_subtitle": "A verification code has been sent to this email address.",
  "email_confirmed": "Email successfully added",
  "pass_added": "Password added",
  "pass_msg": "Your account is now even more secure 💪🏻",
  "email_subtitle": "To recover your password in case you forget it, add your email",
  "confirm_email": "Confirm your Email",
  "confirm_email_text": " Please confirm your email to verify your account and access all platform features.",
  "glad_to_see": "We're glad to see you. Let's upgrade your networking together!",
  "deals_month": "Deals/month",
  "per_month_per": "/per month.",
  "get_start": "Get started with CardBook here",
  "steps": "3 steps to go",
  "deals": "Deals",
  "avg_trans_time": "Avg. trans. time",
  "rating": "Rating",
  "access": "Access",
  "show_more": "Show more",
  "what_are_they_and_how_do_they_differ": "Access Levels: What Are They and How Do They Differ? Click here",
  "has_access": "Has access",
  "change_email": "Changing email",
  "change_email_subtitle": "You can change your email no more than twice every 30 days",
  "change_phone_subtitle": "You can change your phone number no more than twice every 30 days",
  "new_email": "New Email",
  "new_phone": "Phone Number",
  "current_password": "Enter current password",
  "change_email_hint": "Account login password",
  "pin_mail_change": "We have sent the code to the email you entered.",
  "email_success": "Email has been changed to",
  "change_phone": "Change phone number",
  "change_pass": "Change password",
  "new_pass": "New password",
  "cancel": "Cancel",
  "change_pass_confirm": "Confirm password change",
  "change_pass_subtitle": "If you want to set a new password, click \"Change Password\"",
  "pass_success": "Your password has been successfully changed",
  "success": "Success!",
  "phone_success": "Your mobile number has been updated.",
  "error_correct": "One ore more fields have an error. Please check and try again",
  "contact_deleted": "Contact deleted",
  "reset_success": "Your password has been successfully reseted.",
  "click_to_download_your_first_business_card": "Click to download your first business card",
  "card_market_box_title": "This section will be available very soon, ",
  "card_market_box_subtitle": "but in the meantime you can find out your earning potential",
  "add_new_cards": "Add New Business Cards",
  "add_new_cards_text": "Enter the details of the person you want to add information about to check for matches on the platform",
  "referral": "Referral",
  "referral_welcome": "Our referral system is currently exclusive to community owners.",
  "apply_now": "Apply now!",
  "community_owner": "If you're a community owner, you can apply for verification.",
  "ref_approve": "Once approved, you'll gain access to the referral program, and your account will be verified with a checkmark.",
  "verification": "Verification",
  "verif_desc": "Verification ensures a personal profile truly belongs to a community owner. Pass the check to get a special checkmark beside your name, and stand out in search results.",
  "verif_text": "To verify, make sure",
  "link_mob": "Linked mobile phone number",
  "link_mob_required": "Link a mobile phone number to apply.",
  "link_mob_go_settings": "Go to Settings",
  "profile_photo": "Profile photo set",
  "basic_info": "Basic info is filled",
  "community": "Community has 100+ members",
  "ref_form_title": "If you are a community owner, please, fill out the form and tell us a little about yourself and your company.",
  "ref_form_subtitle": "After receiving the application, our manager will contact you directly.",
  "community_name": "Your community name",
  "community_link": "Community link",
  "members_title": "Number of members in your community and location (international/ name of the country with the largest number of members)",
  "description_title": "Briefly describe for whom your community is",
  "value_title": "What is its value",
  "activities_title": "What activities do you organize (zooms, offline meetings)",
  "your_reply": "Your reply",
  "last_login": "Last login time",
  "ref_thanks": "Thank you for your application!",
  "receive_approve": "We've received it and are in the process of verifying your status as a Community Owner. Please expect updates shortly.",
  "close": "Close",
  "referral_form_confirmed": "Your application has been submitted. We'll be in touch with you shortly. Best regards!",
  "link_invite": "Link Invitation",
  "ref_percent": "Get {percent}% of all transactions that your referrals make!",
  "invites": "My Invites",
  "total_invites": "Total Invites",
  "potential_earn": "Potential earnings",
  "transaction_qty": "Transaction quantity",
  "balance": "Overall balance",
  "dynamic_earn": "Dynamics of invites",
  "period": "last 12 months",
  "invite": "Invite",
  "copied": "Copied",
  "restore": "Restore",
  "add_photo_warning": "If you want to add a new contact to your digital bank you have to add a photo",
  "connects_qty": "users can connect you",
  "query_no_results": "Your query returned no results",
  "digital_bank_search": "Digital Bank search",
  "uploading_photo": "Uploading a photo",
  "select_file": "Select a file",
  "upload_text": "You can upload images in JPG or PNG format.",
  "photo_load_error": "Couldn't load this image. Close and choose another file.",
  "photo_save_error": "Couldn't save the photo. Please try again.",
  "having_truble": "If you're having trouble uploading, try selecting a smaller photo.",
  "level": "Level",
  "arts_and_entertainment": "Art and Entertainment",
  "diversified_holding": "Diversified Holding",
  "education": "Education",
  "fashion_and_beauty_industry": "Fashion and Beauty Industry",
  "finance_banks_insurance_investments_": "Finance (Banks/Insurance/Investments)",
  "hotel_and_restaurant_business": "Hotel and Restaurant Business",
  "industry": "Industry",
  "it_internet_digital": "IT, Internet, Digital",
  "marketing": "Marketing",
  "media_and_communications": "Media, Communications, and Mass Media",
  "medicine": "Medicine",
  "private_equility_and_venture_investments": "Private Capital and Venture Investments",
  "real_estate_and_development": "Real Estate and Development",
  "retail_trade": "Retail/Trade",
  "state_and_municipal_administration": "Government and Municipal Management",
  "tourism_and_travel": "Tourism and Travel",
  "construction": "Construction ",
  "finance": "Finance ",
  "information_technology": "Information Technology",
  "jurisprudence": "Jurisprudence",
  "marketing_advertising_pr": "Marketing, advertising, PR ",
  "personnel_management": "Personnel management",
  "procurement": "Procurement",
  "sales": "Sales",
  "strategy": "Strategy",
  "transport_logistics": "Transport logistics",
  "product_development": "Product development",
  "top_management": "Top management",
  "operational_efficiency": "Operational efficiency",
  "design": "Design",
  "increasing_labor_productivity": "Increasing labor productivity",
  "engineering_activities": "Engineering activities",
  "b2b_marketing": "B2B marketing",
  "b2c_marketing": "B2C marketing",
  "digital_marketing": "Digital Marketing",
  "smm": "SMM",
  "analysis_of_the_competitive_environment": "Analysis of the competitive environment",
  "brand_management": "Brand management",
  "market_research": "Market research",
  "positioning": "Positioning",
  "merchandising": "Merchandising",
  "organisation_of_pr_campaigns": "Organization of PR campaigns",
  "marketing_strategy_development": "Marketing strategy development",
  "pr_strategy_development": "PR strategy development",
  "advertising_campaing": "Advertising campaigns",
  "market_segmentation": "Market segmentation",
  "trade_marketing": "Trade marketing",
  "audit": "Audit",
  "financial_statements": "Financial statements",
  "accounting": "Accounting",
  "investments": "Investments",
  "currency_operations": "Currency operations",
  "treasury_department": "Treasury Department",
  "taxes": "Taxes",
  "tax_reporting": "Tax reporting",
  "tax_optimization": "Tax optimization",
  "assessment_of_investment_projects": "Assessment of investment projects",
  "risk_management": "Risk management",
  "investment_management": "Investment management",
  "management_accounting": "Management Accounting",
  "financial_modeling": "Financial modeling",
  "financial_planning": "Financial planning",
  "the_financial_analysis": "The financial analysis",
  "financial_management": "Financial management",
  "fea_procurement_of_services": "FEA",
  "purchase_for_investment_projects": "Purchase for investment projects",
  "supplier_classification_and_segmentation": "Supplier classification and segmentation",
  "procurement_optimization": "Procurement optimization",
  "procurement_planning": "Procurement planning",
  "supply_development": "Supply Development",
  "materials_management": "Materials management",
  "purchasing_management": "Purchasing management",
  "inventory_management": "Inventory Management",
  "category_management": "Category Management",
  "supplier_performance_management": "Supplier performance management",
  "big_data": "Big data",
  "blockchain": "Blockchain",
  "data_mining": "Data mining",
  "administration": "Administration",
  "implementation": "Implementation",
  "architecture": "Architecture",
  "external_audit_of_information_systems": "External audit of information systems",
  "infrastructure": "Infrastructure",
  "programming": "Programming",
  "artificial_intelligence": "Artificial intelligence",
  "computer_security": "Computer security",
  "software_development": "Software development",
  "technical_support": "Technical support",
  "b2b_sales": "B2B Sales",
  "b2c_sales": "B2C Sales",
  "b2g_sales": "B2G Sales",
  "sales_analysis": "Sales analysis",
  "commercial_management": "Commercial management",
  "sales_support": "Sales support",
  "after_sales_post": "After sales post",
  "sales_development": "Sales development",
  "development_of_a_sales_strategy": "Development of a sales strategy",
  "telephone_sales": "Telephone sales",
  "sales_management": "Sales management",
  "civil_engineering": "Civil engineering",
  "road_construction": "Road construction",
  "commercial_real_estate": "Commercial real estate",
  "construction_control": "Construction control",
  "construction_mechanization": "Construction mechanization",
  "property_valuation": "Property valuation",
  "industrial_real_estate": "Industrial real estate",
  "construction_support": "Construction support",
  "property_management": "Property Management",
  "construction_management": "Construction management",
  "developer_functions": "Developer functions",
  "internal_logistics": "Internal logistics",
  "supply_control": "Supply control",
  "logistics_management": "Logistics management",
  "optimization_of_logistics_processes": "Optimization of logistics processes",
  "demand_planning": "Demand Planning",
  "supply_chain_planning": "Supply chain planning",
  "production_planning": "Production planning",
  "distribution_logistics": "Distribution logistics",
  "warehouse_logistics": "Warehouse Logistics",
  "transportation_management": "Transportation management",
  "supply_chain_management": "Supply Chain Management",
  "staff_adaptation": "Staff adaptation",
  "hr_records_management": "HR records management",
  "compensation_and_benefits": "Compensation and benefits",
  "motivation": "Motivation",
  "personnel_assessment": "Personnel assessment",
  "professional_competencies": "Professional competencies",
  "development": "Development",
  "recruitment": "Recruitment",
  "development_of_policies_and_procedures": "Development of policies and procedures",
  "staff_reduction": "Staff reduction",
  "talent_management": "Talent management",
  "managerial_competencies": "Managerial competencies",
  "copyright": "Copyright",
  "administrative_law": "Administrative law",
  "shareholding_law": "Shareholding law",
  "audit_of_legal_documents": "Audit of legal documents",
  "civil_law": "Civil law",
  "corporate_governance": "Corporate Governance",
  "international_law": "International law",
  "tax_law": "Tax law",
  "development_of_legal_documents": "Development of legal documents",
  "litigation": "Litigation",
  "customs_law": "Customs law",
  "labor_law": "Labor law",
  "economic_law": "Economic law",
  "private_right": "Private right",
  "business_analysis": "Business analysis",
  "business_process_optimization": "Business process optimization",
  "project_planning": "Project Planning",
  "project_documentation": "Project documentation",
  "development_of_technical_specifications": "Development of technical specifications",
  "project_management": "Project management",
  "digital_strategy": "Digital strategy",
  "corporate_strategy": "Corporate strategy",
  "marketing_strategy": "Marketing strategy",
  "modeling": "Modeling",
  "strategy_development": "Strategy Development",
  "implementation_of_the_strategy": "Implementation of the strategy",
  "strategic_analysis": "Strategic Analysis",
  "strategic_consulting": "Strategic Consulting",
  "strategic_marketing": "Strategic Marketing",
  "strategic_management": "Strategic management",
  "strategic_planning": "Strategic planning",
  "positioning_strategy": "Positioning strategy ",
  "sales_strategy": "Sales strategy",
  "promotion_strategy": "Promotion strategy",
  "development_strategy": "Development strategy",
  "strategy_management": "Strategy management",
  "b2b": "B2B",
  "b2c": "B2C",
  "b2g": "B2G",
  "c2c": "C2C",
  "fintech": "Fintech",
  "business_modeling": "Business modeling",
  "conversion_boost": "Conversion boost",
  "e_learning": "E-learning",
  "electronic_commerce": "Electronic commerce",
  "electronic_banking": "Electronic banking",
  "email_marketing": "Email Marketing",
  "electronic_information_exchange": "Electronic information exchange",
  "analysis_of_consumer_preferences": "Analysis of consumer preferences",
  "testing": "Testing",
  "export_sales ": "Export sales",
  "construction_development": "Construction development",
  "logistics_business_modeling": "Logistics business modeling",
  "hr_strategy": "HR strategy",
  "corporate_law": "Corporate law",
  "criminal_law": "Criminal law",
  "analytics": "Analytics",
  "road_map": "Road map",
  "usability": "Usability",
  "use_case_analysis": "Use case analysis",
  "bringing_the_product_to_market": "Bringing the product to market",
  "product_interface_design": "Interface desig",
  "launch_of_new_products": "Launch of new products",
  "needs_research": "Needs Research",
  "industrial_design": "Industrial Design",
  "new_product_development": "New product development",
  "development_of_a_product_development_strategy": "Development of a product development strategy",
  "product_management": "Product Management",
  "economic_analysis": "Economic analysis",
  "crisis_management": "Crisis management",
  "corporate_leadership": "Corporate leadership",
  "organisation_management": "Organisation management",
  "operations_management": "Operations management",
  "organizational_design": "Organizational design",
  "process_and_project_management": "Process and project management",
  "top_risk_management": "Risk management",
  "top_strategic_management": "Strategic management",
  "business_process_management": "Business Process Management",
  "improving_the_quality_of_the_product_service ": "Improving the quality of the product/ service",
  "cost_reduction": "Cost reduction",
  "improvement_of_business_processes": "Improvement of business processes",
  "3d_visualization": "3D visualization",
  "layout": "Layout",
  "exhibition_stage_design": "Exhibition/stage design",
  "vjing_vj": "VJing (VJ)",
  "print_design": "Print design",
  "presentation_design": "Presentation design",
  "illustration": "Illustration",
  "interface_design": "Interface design",
  "infographics": "Infographics",
  "motion_design": "Motion design",
  "ux_ui_design": "UX/UI design",
  "identity_development": "Identity development",
  "character_development": "Character development",
  "creating_a_brand_book": "Creating a brand book",
  "fea": "FEA",
  "procurement_of_services": "Procurement of services",
  "update_link": "Update Link",
  "how_add_card": "How to add a business card to Digital Bank in 3 clicks?",
  "levels_mean": "What do the A, B, C levels mean?",
  "how_potential_income": "How does the potential income calculator work?",
  "how_referral_system": "How to apply for the referral system?",
  "answers_community": "Answers to these and other questions are available in our bot and community",
  "join_community": "I want to join the community",
  "get_help": "Get help",
  "your_help": "Your Help Center",
  "help_text": "Questions, problems, ideas — we're ready to assist and move forward together 👇🏻",
  "complete_profile_occu": "Complete profile",
  "where_begin": "Where to begin",
  "afghanistan": "Afghanistan",
  "aland_islands": "Aland Islands",
  "albania": "Albania",
  "algeria": "Algeria",
  "american_samoa": "American Samoa",
  "andorra": "Andorra",
  "angola": "Angola",
  "anguilla": "Anguilla",
  "antarctica": "Antarctica",
  "antigua_and_barbuda": "Antigua and Barbuda",
  "argentina": "Argentina",
  "armenia": "Armenia",
  "aruba": "Aruba",
  "australia": "Australia",
  "austria": "Austria",
  "azerbaijan": "Azerbaijan",
  "bahamas": "Bahamas",
  "bahrain": "Bahrain",
  "bangladesh": "Bangladesh",
  "barbados": "Barbados",
  "belarus": "Belarus",
  "belgium": "Belgium",
  "belize": "Belize",
  "benin": "Benin",
  "bermuda": "Bermuda",
  "bhutan": "Bhutan",
  "bolivia_plurinational_state_of": "Bolivia, Plurinational State of",
  "bosnia_and_herzegovina": "Bosnia and Herzegovina",
  "botswana": "Botswana",
  "brazil": "Brazil",
  "british_indian_ocean_territory": "British Indian Ocean Territory",
  "brunei_darussalam": "Brunei Darussalam",
  "bulgaria": "Bulgaria",
  "burkina_faso": "Burkina Faso",
  "burundi": "Burundi",
  "cambodia": "Cambodia",
  "cameroon": "Cameroon",
  "canada": "Canada",
  "cape_verde": "Cape Verde",
  "cayman_islands": "Cayman Islands",
  "central_african_republic": "Central African Republic",
  "chad": "Chad",
  "chile": "Chile",
  "china": "China",
  "christmas_island": "Christmas Island",
  "cocos_keeling_islands": "Cocos (Keeling) Islands",
  "colombia": "Colombia",
  "comoros": "Comoros",
  "congo": "Congo",
  "congo_the_democratic_republic_of_the_congo": "Congo, the Democratic Republic of the",
  "cook_islands": "Cook Islands",
  "costa_rica": "Costa Rica",
  "cote_d_ivoire": "Cote d'Ivoire",
  "croatia": "Croatia",
  "cuba": "Cuba",
  "cyprus": "Cyprus",
  "czech_republic": "Czech Republic",
  "denmark": "Denmark",
  "djibouti": "Djibouti",
  "dominica": "Dominica",
  "dominican_republic": "Dominican Republic",
  "ecuador": "Ecuador",
  "egypt": "Egypt",
  "el_salvador": "El Salvador",
  "equatorial_guinea": "Equatorial Guinea",
  "eritrea": "Eritrea",
  "estonia": "Estonia",
  "ethiopia": "Ethiopia",
  "falkland_islands_malvinas_": "Falkland Islands (Malvinas)",
  "faroe_islands": "Faroe Islands",
  "fiji": "Fiji",
  "finland": "Finland",
  "france": "France",
  "french_guiana": "French Guiana",
  "french_polynesia": "French Polynesia",
  "gabon": "Gabon",
  "gambia": "Gambia",
  "georgia": "Georgia",
  "germany": "Germany",
  "ghana": "Ghana",
  "gibraltar": "Gibraltar",
  "greece": "Greece",
  "greenland": "Greenland",
  "grenada": "Grenada",
  "guadeloupe": "Guadeloupe",
  "guam": "Guam",
  "guatemala": "Guatemala",
  "guernsey": "Guernsey",
  "guinea": "Guinea",
  "guinea_bissau": "Guinea-Bissau",
  "guyana": "Guyana",
  "haiti": "Haiti",
  "holy_see_vatican_city_state_": "Holy See (Vatican City State)",
  "honduras": "Honduras",
  "hong_kong": "Hong Kong",
  "hungary": "Hungary",
  "iceland": "Iceland",
  "india": "India",
  "indonesia": "Indonesia",
  "iran_islamic_republic_of_persian_gulf": "Iran, Islamic Republic of Persian Gulf",
  "iraq": "Iraq",
  "ireland": "Ireland",
  "isle_of_man": "Isle of Man",
  "israel": "Israel",
  "italy": "Italy",
  "jamaica": "Jamaica",
  "japan": "Japan",
  "jersey": "Jersey",
  "jordan": "Jordan",
  "kazakhstan": "Kazakhstan",
  "kenya": "Kenya",
  "kiribati": "Kiribati",
  "korea_democratic_people_s_republic_of_korea": "Korea, Democratic People's Republic of Korea",
  "korea_republic_of_south_korea": "Korea, Republic of South Korea",
  "kuwait": "Kuwait",
  "kyrgyzstan": "Kyrgyzstan",
  "laos": "Laos",
  "latvia": "Latvia",
  "lebanon": "Lebanon",
  "lesotho": "Lesotho",
  "liberia": "Liberia",
  "libyan_arab_jamahiriya": "Libyan Arab Jamahiriya",
  "liechtenstein": "Liechtenstein",
  "lithuania": "Lithuania",
  "luxembourg": "Luxembourg",
  "macao": "Macao",
  "macedonia": "Macedonia",
  "madagascar": "Madagascar",
  "malawi": "Malawi",
  "malaysia": "Malaysia",
  "maldives": "Maldives",
  "mali": "Mali",
  "malta": "Malta",
  "marshall_islands": "Marshall Islands",
  "martinique": "Martinique",
  "mauritania": "Mauritania",
  "mauritius": "Mauritius",
  "mayotte": "Mayotte",
  "mexico": "Mexico",
  "micronesia_federated_states_of_micronesia": "Micronesia, Federated States of Micronesia",
  "moldova": "Moldova",
  "monaco": "Monaco",
  "mongolia": "Mongolia",
  "montenegro": "Montenegro",
  "montserrat": "Montserrat",
  "morocco": "Morocco",
  "mozambique": "Mozambique",
  "myanmar": "Myanmar",
  "namibia": "Namibia",
  "nauru": "Nauru",
  "nepal": "Nepal",
  "netherlands": "Netherlands",
  "netherlands_antilles": "Netherlands Antilles",
  "new_caledonia": "New Caledonia",
  "new_zealand": "New Zealand",
  "nicaragua": "Nicaragua",
  "niger": "Niger",
  "nigeria": "Nigeria",
  "niue": "Niue",
  "norfolk_island": "Norfolk Island",
  "northern_mariana_islands": "Northern Mariana Islands",
  "norway": "Norway",
  "oman": "Oman",
  "pakistan": "Pakistan",
  "palau": "Palau",
  "palestinian_territory_occupied": "Palestinian Territory, Occupied",
  "panama": "Panama",
  "papua_new_guinea": "Papua New Guinea",
  "paraguay": "Paraguay",
  "peru": "Peru",
  "philippines": "Philippines",
  "pitcairn": "Pitcairn",
  "poland": "Poland",
  "portugal": "Portugal",
  "puerto_rico": "Puerto Rico",
  "qatar": "Qatar",
  "romania": "Romania",
  "russia": "Russia",
  "rwanda": "Rwanda",
  "reunion": "Reunion",
  "saint_barthelemy": "Saint Barthelemy",
  "saint_helena_ascension_and_tristan_da_cunha": "Saint Helena, Ascension and Tristan da Cunha",
  "saint_kitts_and_nevis": "Saint Kitts and Nevis",
  "saint_lucia": "Saint Lucia",
  "saint_martin": "Saint Martin",
  "saint_pierre_and_miquelon": "Saint Pierre and Miquelon",
  "saint_vincent_and_the_grenadines": "Saint Vincent and the Grenadines",
  "samoa": "Samoa",
  "san_marino": "San Marino",
  "sao_tome_and_principe": "Sao Tome and Principe",
  "saudi_arabia": "Saudi Arabia",
  "senegal": "Senegal",
  "serbia": "Serbia",
  "seychelles": "Seychelles",
  "sierra_leone": "Sierra Leone",
  "singapore": "Singapore",
  "slovakia": "Slovakia",
  "slovenia": "Slovenia",
  "solomon_islands": "Solomon Islands",
  "somalia": "Somalia",
  "south_africa": "South Africa",
  "south_sudan": "South Sudan",
  "south_georgia_and_the_south_sandwich_islands": "South Georgia and the South Sandwich Islands",
  "spain": "Spain",
  "sri_lanka": "Sri Lanka",
  "sudan": "Sudan",
  "suriname": "Suriname",
  "svalbard_and_jan_mayen": "Svalbard and Jan Mayen",
  "swaziland": "Swaziland",
  "sweden": "Sweden",
  "switzerland": "Switzerland",
  "syrian_arab_republic": "Syrian Arab Republic",
  "taiwan": "Taiwan",
  "tajikistan": "Tajikistan",
  "tanzania_united_republic_of_tanzania": "Tanzania, United Republic of Tanzania",
  "thailand": "Thailand",
  "timor_leste": "Timor-Leste",
  "togo": "Togo",
  "tokelau": "Tokelau",
  "tonga": "Tonga",
  "trinidad_and_tobago": "Trinidad and Tobago",
  "tunisia": "Tunisia",
  "turkey": "Turkey",
  "turkmenistan": "Turkmenistan",
  "turks_and_caicos_islands": "Turks and Caicos Islands",
  "tuvalu": "Tuvalu",
  "uganda": "Uganda",
  "ukraine": "Ukraine",
  "united_arab_emirates": "United Arab Emirates",
  "united_kingdom": "United Kingdom",
  "united_states": "United States",
  "uruguay": "Uruguay",
  "uzbekistan": "Uzbekistan",
  "vanuatu": "Vanuatu",
  "venezuela_bolivarian_republic_of_venezuela": "Venezuela, Bolivarian Republic of Venezuela",
  "vietnam": "Vietnam",
  "virgin_islands_british": "Virgin Islands, British",
  "virgin_islands_u_s_": "Virgin Islands, U.S.",
  "wallis_and_futuna": "Wallis and Futuna",
  "yemen": "Yemen",
  "zambia": "Zambia",
  "zimbabwe": "Zimbabwe",
  "okay": "Okay",
  "profile": "Profile",
  "displayed_here": "Your contacts will be displayed here",
  "avg_price": "Avg. price",
  "delete_from_bank": "Remove from Digital Bank",
  "levels_on_platform": "Access levels  on the platform",
  "text_banner": "Learn what they are and how to set them up correctly for your contacts by clicking on this banner",
  "levels": "Access levels",
  "on_platform": "on the platform",
  "banner_help": "Need Help?",
  "text_banner_help": "Find answers and reach out to us in the support section. Your comfort is our priority.",
  "upload_card": "Upload your first business card here",
  "welcome_digital": "Welcome to Digital Bank",
  "text_digital_banner": "Your personal digital bank of business cards where  you can store and add your most valuable contacts",
  "banner_card_book": "CardMarket",
  "text_card_banner": "Your personal business card marketplace is being developed. Use the calculator to find out your potential earnings.",
  "level_plat": "Access levels on the platform",
  "text_abc_banner": "Learn what they are and how to set them up correctly for your contacts by clicking on this banner",
  "contacts_s": "Contacts",
  "invite_header": "Invite to CardBook",
  "invite_text": "Everyone who registers becomes part of your DigitalBank.",
  "link_one": "Link",
  "contact": "Contact",
  "active_link": "Link is active for 48 hours",
  "visible": "Visible only to you",
  "text_pop": "Used for your convenience and quick search",
  "add_to_my_bank": "Add to my Digital Bank",
  "additional_account": "Additional account protection",
  "to_login": "To login, change security settings",
  "necessary_to_reset": "This is necessary to reset your password, activate your account and receive transaction notifications.",
  "comment_modal": "A - Close contacts, B - Regular, C - Acquaintances",
  "connec_text": "Add a link to your social network or messenger to stay in touch outside the platform.",
  "click_connec": "One-Click Connection",
  "your_link": "Your link",
  "text_contact": "The user has left a convenient way to contact them.",
  "no_link": "This user has no specified contact information.",
  "afar": "Afar",
  "abkhazian": "Abkhazian",
  "avestan": "Avestan",
  "afrikaans": "Afrikaans",
  "akan": "Akan",
  "amharic": "Amharic",
  "aragonese": "Aragonese",
  "arabic": "Arabic",
  "assamese": "Assamese",
  "avaric": "Avaric",
  "aymara": "Aymara",
  "azerbaijani": "Azerbaijani",
  "bashkir": "Bashkir",
  "belarusian": "Belarusian",
  "bulgarian": "Bulgarian",
  "bihari_languages": "Bihari languages",
  "bislama": "Bislama",
  "bambara": "Bambara",
  "bengali": "Bengali",
  "tibetan": "Tibetan",
  "breton": "Breton",
  "bosnian": "Bosnian",
  "catalan": "Catalan",
  "chechen": "Chechen",
  "chamorro": "Chamorro",
  "corsican": "Corsican",
  "cree": "Cree",
  "czech": "Czech",
  "chuvash": "Chuvash",
  "welsh": "Welsh",
  "danish": "Danish",
  "german": "German",
  "divehi": "Divehi",
  "dzongkha": "Dzongkha",
  "ewe": "Ewe",
  "greek_modern_1453_": "Greek, Modern (1453-)",
  "english": "English",
  "esperanto": "Esperanto",
  "spanish": "Spanish",
  "estonian": "Estonian",
  "basque": "Basque",
  "persian": "Persian",
  "fulah": "Fulah",
  "finnish": "Finnish",
  "fijian": "Fijian",
  "faroese": "Faroese",
  "french": "French",
  "western_frisian": "Western Frisian",
  "irish": "Irish",
  "gaelic": "Gaelic",
  "galician": "Galician",
  "guarani": "Guarani",
  "gujarati": "Gujarati",
  "manx": "Manx",
  "hausa": "Hausa",
  "hebrew": "Hebrew",
  "hindi": "Hindi",
  "hiri_motu": "Hiri Motu",
  "croatian": "Croatian",
  "haitian": "Haitian",
  "hungarian": "Hungarian",
  "armenian": "Armenian",
  "herero": "Herero",
  "indonesian": "Indonesian",
  "igbo": "Igbo",
  "sichuan_yi": "Sichuan Yi",
  "inupiaq": "Inupiaq",
  "ido": "Ido",
  "icelandic": "Icelandic",
  "italian": "Italian",
  "inuktitut": "Inuktitut",
  "japanese": "Japanese",
  "javanese": "Javanese",
  "georgian": "Georgian",
  "kongo": "Kongo",
  "kikuyu": "Kikuyu",
  "kuanyama": "Kuanyama",
  "kazakh": "Kazakh",
  "greenlandic": "Greenlandic",
  "central_khmer": "Central Khmer",
  "kannada": "Kannada",
  "korean": "Korean",
  "kanuri": "Kanuri",
  "kashmiri": "Kashmiri",
  "kurdish": "Kurdish",
  "komi": "Komi",
  "cornish": "Cornish",
  "kirghiz": "Kirghiz",
  "latin": "Latin",
  "luxembourgish": "Luxembourgish",
  "ganda": "Ganda",
  "limburgan": "Limburgan",
  "lingala": "Lingala",
  "lao": "Lao",
  "lithuanian": "Lithuanian",
  "luba_katanga": "Luba-Katanga",
  "latvian": "Latvian",
  "malagasy": "Malagasy",
  "marshallese": "Marshallese",
  "maori": "Maori",
  "macedonian": "Macedonian",
  "malayalam": "Malayalam",
  "mongolian": "Mongolian",
  "marathi": "Marathi",
  "malay": "Malay",
  "maltese": "Maltese",
  "burmese": "Burmese",
  "norwegian_bokm_l": "Norwegian Bokmål",
  "ndebele_north": "Ndebele, North",
  "nepali": "Nepali",
  "ndonga": "Ndonga",
  "dutch": "Dutch",
  "norwegian_nynorsk": "Norwegian Nynorsk",
  "norwegian": "Norwegian",
  "south_ndebele": "South Ndebele",
  "navajo": "Navajo",
  "chichewa": "Chichewa",
  "occitan": "Occitan",
  "ojibwa": "Ojibwa",
  "oromo": "Oromo",
  "oriya": "Oriya",
  "ossetian": "Ossetian",
  "panjabi": "Panjabi",
  "pali": "Pali",
  "polish": "Polish",
  "pushto": "Pushto",
  "portuguese": "Portuguese",
  "quechua": "Quechua",
  "romansh": "Romansh",
  "rundi": "Rundi",
  "romanian": "Romanian",
  "russian": "Russian",
  "kinyarwanda": "Kinyarwanda",
  "sanskrit": "Sanskrit",
  "sardinian": "Sardinian",
  "sindhi": "Sindhi",
  "northern_sami": "Northern Sami",
  "sango": "Sango",
  "sinhala": "Sinhala",
  "slovak": "Slovak",
  "slovenian": "Slovenian",
  "samoan": "Samoan",
  "shona": "Shona",
  "somali": "Somali",
  "albanian": "Albanian",
  "serbian": "Serbian",
  "swati": "Swati",
  "sotho_southern": "Sotho, Southern",
  "sundanese": "Sundanese",
  "swedish": "Swedish",
  "swahili": "Swahili",
  "tamil": "Tamil",
  "telugu": "Telugu",
  "tajik": "Tajik",
  "thai": "Thai",
  "tigrinya": "Tigrinya",
  "turkmen": "Turkmen",
  "tagalog": "Tagalog",
  "tswana": "Tswana",
  "tonga_tonga_islands_": "Tonga (Tonga Islands)",
  "turkish": "Turkish",
  "tsonga": "Tsonga",
  "tatar": "Tatar",
  "twi": "Twi",
  "tahitian": "Tahitian",
  "uighur": "Uighur",
  "ukrainian": "Ukrainian",
  "urdu": "Urdu",
  "uzbek": "Uzbek",
  "venda": "Venda",
  "vietnamese": "Vietnamese",
  "volap_k": "Volapük",
  "walloon": "Walloon",
  "wolof": "Wolof",
  "xhosa": "Xhosa",
  "yiddish": "Yiddish",
  "yoruba": "Yoruba",
  "zhuang": "Zhuang",
  "chinese": "Chinese",
  "zulu": "Zulu",
  "contact_mod": "Contact",
  "profile_photo_modal": "Profile photo",
  "card_photo": "Card photo",
  "save_changed": "Save Changes",
  "choose_photo": "Choose a location for small photos. The thumbnail you select will be used in your profile picture, private messages, and contact cards.",
  "remove_photo": "Remove photo",
  "text_remove": "Are you sure you want to delete your profile photo?  If you delete a photo, your profile will be hidden from the general search on the platform",
  "contacts_digital": "Contacts",
  "comment_modal_info": "A comment on how you met, what was agreed upon, a description of the contact",
  "view_more": "View info",
  "chart_photo": "Chat photo",
  "code_confirmation": "A confirmation code will be sent to this email.",
  "level_a": "Level A",
  "level_b": "Level B",
  "level_c": "Level C",
  "community_owner_check": "Community owner",
  "page_verified": "The page is verified",
  "contact_in_bank": "This contact is already in your Digital Bank. You can update or change his/her information as needed.",
  "restore_to_bank": "This contact was already in your Digital Bank. You can restore it to have access to manage the contact again.",
  "count": "Your potential income here",
  "edit_only": "Edit",
  "select_direction": "First select Direction",
  "soon": "Soon...",
  "comment_modal_a": "A - Close contacts,",
  "comment_modal_b": "B - Regular,",
  "comment_modal_c": "C - Acquaintances",
  "A": "Level A",
  "B": "Level B",
  "C": "Level C",
  "selected": "Selected",
  "edit_contact_bank": "You have successfully update a contact",
  "platform_language": "Platform Language",
  "please_fill_field": "Please fill in all required fields",
  "empty_field": "Empty field",
  "all_contacts": "All contacts",
  "edit_folder": "Edit",
  "folders":"Folders",
  "create_folder": "You can create folders with the contacts you need and switch between them",
  "my_folders": "My folders",
  "create_new_folder": "Create a new folder",
  "folder_contacts":"contacts",
  "delete_folder": "Delete folder",
  "subtitle_delete":" Should I delete this folder?",
  "affect_contact": "This will not affect the contacts that are in it.",
  "limit_folder": "Folder creation limit reached",
  "new_folder": "New folder",
  "folder_name": "Folder name",
  "selected_contacts": "Selected contacts",
  "add_contacts": "Add contacts",
  "select_contact_show": "Select the contacts you want to show in this folder",
  "add_folder_name": "You must add a folder name to select contacts",
  "must_add": "You must add at least one contact",
  "no_result": "Your query returned no results",
  "congratulation": "Congratulations!",
  "folder_success": "Folder created successfully",
  "view_original_language": "View in original language",
  "view_original": "View original",
  "show_translation": "Show translation",
  "language_settings": "Language settings",
  "check_spam": "Check your spam folder if the code hasn’t arrived.",
  "card_not_a_connection": "This is another user's card, not a person you can connect with directly. Get access to it from the card market to add it to your Digital Bank."
}
